export enum TipoPermissao {
    TECNICOCADOMA = 'tecnicocadoma',
    ADMINISTRADOR = 'administrador',
    ANALISTA = 'analista',
    OPERADOR = 'operador'
}